import React from 'react';
import './Editable.css';
import {Editable, EditableProps} from "./Editable";
import {useEditable} from "./EditableContext";

type Props<EnclosingType extends object> = EditableProps<EnclosingType, string> & {
  inputType: 'text' | 'tel' | 'email' | 'number' | 'url'
}

export const EditableStringField = <EnclosingType extends object>(props: Props<EnclosingType>) => {

  const {editing, mode, value, setValue} = useEditable(props);

  if (mode == 'create' || (mode == 'update' && editing && !props.immutable)) {
    return <Editable {...props}>
      <input className={'EditableEditing'} type={props.inputType}
             value={value ?? undefined}
             onChange={event => setValue(event.target.value)}/>
    </Editable>
  }


  return <Editable {...props}>
    <div className={'EditableNotEditing'}>{value}</div>
  </Editable>
}